import validator from 'validator';

export { default as withMappedState } from './withMappedState';

const uuid = require('uuid/v4');

export const delimiterSeparatedToTitleCase = (delimter, string) => (
  string.split(delimter).map(word => (
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  )).join(' ')
);

export const areArraysEqual = (first, second) => {
  if (first.length !== second.length) {
    return false;
  }
  return first.every(element => second.includes(element));
};

// Formats a number to include commas.
// We need to do this manually instead of using toLocaleString because
// toLocaleString won't allow decimals to be entered
// Regex found here: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
// Ex: 1234567.890 => 1,234,567.890
export const formatNumber = (val) => {
  if (!val) {
    return '0';
  }
  const parts = val.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const htmlDecode = (input) => {
  // if the input is an empty string, DOMParser return null for documentElement on ie11
  if (!input) {
    return '';
  }

  const doc = new window.DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
};

export const isNumeric = (value) => {
  if (!value) {
    return false;
  }
  return !isNaN(value);
};

export const arrayToObjWithValues = (arr, value) => {
  const result = {};
  arr.forEach((key) => {
    result[key] = value;
  });

  return result;
};

export const validateEmailAddresses = (potentialEmailAddresses) => {
  const validEmails = potentialEmailAddresses.filter(
    potentialEmail => validator.isEmail(potentialEmail.trim()),
  );
  return validEmails.length === potentialEmailAddresses.length;
};

// from https://stackoverflow.com/questions/5598743/finding-elements-position-relative-to-the-document#answer-26230989
export const getCoords = (elem) => {
  const box = elem.getBoundingClientRect();

  const body = document.body;
  const docElem = document.documentElement;

  const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

  const clientTop = docElem.clientTop || body.clientTop || 0;
  const clientLeft = docElem.clientLeft || body.clientLeft || 0;

  const top = (box.top + scrollTop) - clientTop;
  const left = (box.left + scrollLeft) - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
};

// from https://stackoverflow.com/questions/22607806/defer-execution-for-es6-template-literals/22619256#22619256
export const templatize = (literals, ...substitutions) => ({
  format: (...templateArgs) => {
    const strArr = [];
    let i = 0;
    let k = 0;
    for (; i < literals.length; i += 1) {
      strArr[k += 1] = literals[i];
      strArr[k += 1] = templateArgs[substitutions[i]];
    }
    return strArr.join('');
  },
});

// takes in an integer dateComponent and returns a string of that number left padded to two digits
// with a zero
const padDateComponent = (dateComponent) => {
  const formattedDateComponent = dateComponent.toString();
  return formattedDateComponent.length > 1 ? formattedDateComponent : `0${dateComponent}`;
};

export const formatDate = (date, shouldPadMonth = true) => {
  // return the given date in MM/dd/yyyy format
  const year = date.getFullYear();

  let month;
  if (shouldPadMonth) {
    month = padDateComponent(1 + date.getMonth());
  } else {
    month = 1 + date.getMonth();
  }

  const day = padDateComponent(date.getDate());

  return `${month}/${day}/${year}`;
};

export const formatDateWithTime = date => (
  date.toLocaleTimeString('en-US', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }).replace(',', '')
);

// wrap in utils method so we can mock this while testing
// currently, there isn't a clean way to mock npm modules
export const uuidV4 = () => (uuid());

/**
 * Binds all specified methods to obj.  By default this replaces all
 * methods with instance-bound versions, and is meant to be a substitute
 * for lots of "this.whatever = this.whatever.bind(this)" in
 * component constructors.
 * Args:
 *   obj: an object to which the supplied methods should be bound, potentially the
 *        location of a method, and by default the attach point for the bound method.
 *   methods: an array of methods to bind.  These may be functions or strings.  If they
 *            are strings, they are understood to be methods defined on 'obj'.
 */
export const bindMethods = (obj, methods) => {
  methods.forEach((method) => {
    if (typeof obj[method] === 'function') {
      // eslint-disable-next-line no-param-reassign
      obj[method] = obj[method].bind(obj);
    } else {
      // we actually want this to be logged but not fail.
      // eslint-disable-next-line no-console
      console.warn(`Attempted to bind undefined method ${method} of class ${obj.constructor.name}`);
    }
  });
};




// WEBPACK FOOTER //
// ./src-react/Utils/index.jsx